export function loadAsset(path: string): string {
    return process.env.NEXT_PUBLIC_ENV_CDN_HOST_NAME + '/' + path.replace(/^\/+/, '');
}
